import eventify from 'ngraph.events';

const bus = eventify({});

export default bus;